import { getChatNotificationStatus } from "../../../api/messages";
import { GET_CHAT_NOTIFICATION_STATUS } from "constants/reactQueryKeys";
import { useQuery } from "react-query";

/**
 * React Query hook for fetching the notification status of a specific chat for a given user.
 *
 * @param {number | string} chatId - The ID of the chat to check notification status for.
 * @param {number | string} userId - The ID of the user whose notification status is being queried.
 * @param {Object} [options] - Optional settings.
 * @param {number | null} [options.pollingMs=null] - Optional polling interval in milliseconds. If null, polling is disabled.
 */
export const useGetChatNotificationStatus = (chatId, userId, { pollingMs = null } = {}) => {
  const { data, isLoading, refetch } = useQuery(
    [GET_CHAT_NOTIFICATION_STATUS, chatId, userId],
    () => getChatNotificationStatus(chatId, userId),
    {
      enabled: !!userId && !!chatId,
      refetchInterval: pollingMs ?? false,
    }
  );

  return {
    notificationsEnabled: data?.data,
    notificationStatusLoading: isLoading,
    refetchNotificationStatus: refetch,
  };
};
